import * as roles from '../../../services/access/roles';
import * as subscriptionTypes from "../../company/subscriptionType";

export default [
    {
        id: 'total-statistik',
        to: '/statistik/total',
        title: 'Total',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'nyhed-statistik',
        to: '/statistik/nyhed',
        title: 'Nyheder',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
        ],
    },
    {
        id: 'jobopslag-statistik',
        to: '/statistik/jobopslag',
        title: 'Jobopslag',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
        ],
    },
    {
        id: 'maskine-statistik',
        to: '/statistik/maskine',
        title: 'Køb & salg',
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'profil-statistik',
        to: '/statistik/profil',
        title: 'Profil',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.MASKINSTATIONER_MINI,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'kurser-statistik',
        to: '/statistik/kurser',
        title: 'Arrangementer eller kurser',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'produkter-statistik',
        to: '/statistik/produkter',
        title: 'Produkter mv.',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
];


// WEBPACK FOOTER //
// ./web/src/components/navigation/items/analyticsItems.js